import React from 'react';
import { injectIntl } from 'react-intl';

import config from '../../config';

const languageSupportComponentDefaultPropLanguages = [...Object.keys(config.languages)];

const LanguageSupportComponent = ({ intl, languages = languageSupportComponentDefaultPropLanguages, children }) => {
  

  const currentLanguage = intl.locale;

  if (!languages.includes(currentLanguage)) {
    return null;
  }

  return <>{children}</>;
};

const LanguageSupport = injectIntl(LanguageSupportComponent);

export default LanguageSupport;
